import { TechnicalProof } from "./TechnicalProof";

const describeGate = (gate) => {
  if (!gate) return "always visible";
  const parts = [];
  if (gate.only_roles) parts.push(`only ${gate.only_roles.join(", ")}`);
  if (gate.hidden_for_roles) parts.push(`hidden for ${gate.hidden_for_roles.join(", ")}`);
  if (gate.permission) parts.push(`permission ${gate.permission}`);
  if (gate.feature) parts.push(`feature ${gate.feature}`);
  return parts.length ? parts.join(" · ") : "always visible";
};

const Section = ({ title, testId, children }) => (
  <section
    data-testid={testId}
    style={{ border: "1px solid #e2e5ea", borderRadius: "8px", padding: "0.6rem 0.8rem", marginBottom: "0.5rem", background: "#fbfcfe" }}
  >
    <h4 style={{ margin: "0 0 0.4rem", fontSize: "0.82rem" }}>{title}</h4>
    {children}
  </section>
);

export const FiveSectionDetail = ({ sections }) => {
  if (!sections) return null;
  return (
    <div data-testid="access-studio-five-section-detail">
      <Section title="What They See (menu)" testId="access-studio-section-see">
        {(sections.what_they_see || []).length ? (
          <ul style={{ margin: 0, paddingLeft: "1.1rem", fontSize: "0.8rem" }}>
            {sections.what_they_see.map((page) => (
              <li key={page.path}>
                <strong>{page.label}</strong> <code>{page.path}</code>
              </li>
            ))}
          </ul>
        ) : (
          <p style={{ margin: 0, fontSize: "0.8rem", color: "#6b7280" }}>No menu items visible for this role.</p>
        )}
        {(sections.also_url_reachable || []).length > 0 && (
          <div data-testid="access-studio-url-reachable" style={{ marginTop: "0.5rem" }}>
            <p style={{ margin: "0 0 0.25rem", fontSize: "0.75rem", color: "#b45309", fontWeight: 600 }}>
              Also reachable by direct URL (not in menu):
            </p>
            <ul style={{ margin: 0, paddingLeft: "1.1rem", fontSize: "0.78rem", color: "#92400e" }}>
              {sections.also_url_reachable.map((page) => (
                <li key={page.path}>
                  <code>{page.path}</code> <small>({page.label})</small>
                </li>
              ))}
            </ul>
          </div>
        )}
      </Section>
      <Section title="What They Can Do" testId="access-studio-section-do">
        {(sections.what_they_can_do || []).length ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "0.3rem" }}>
            {sections.what_they_can_do.map((permission) => (
              <span
                key={permission}
                style={{ background: "#eef2ff", borderRadius: "6px", fontSize: "0.72rem", padding: "0.12rem 0.45rem" }}
              >
                {permission}
              </span>
            ))}
          </div>
        ) : (
          <p style={{ margin: 0, fontSize: "0.8rem", color: "#6b7280" }}>No granted permissions.</p>
        )}
      </Section>
      <Section title="Fields and Data" testId="access-studio-section-fields">
        <p style={{ margin: 0, fontSize: "0.8rem" }}>{sections.fields_and_data?.note}</p>
        {(sections.fields_and_data?.supervisor_denylist || []).length > 0 && (
          <p style={{ margin: "0.3rem 0 0", fontSize: "0.75rem", color: "#991b1b" }}>
            Stripped server-side: {sections.fields_and_data.supervisor_denylist.join(", ")}
          </p>
        )}
      </Section>
      <Section title="Gates and Rules" testId="access-studio-section-gates">
        {(sections.gates_and_rules || []).length ? (
          <ul style={{ margin: 0, paddingLeft: "1.1rem", fontSize: "0.8rem" }}>
            {sections.gates_and_rules.map((gate) => (
              <li key={gate.path}>
                <code>{gate.path}</code> · {describeGate(gate.gate)}
              </li>
            ))}
          </ul>
        ) : (
          <p style={{ margin: 0, fontSize: "0.8rem", color: "#6b7280" }}>No menu gates apply.</p>
        )}
      </Section>
      <Section title="Technical Proof" testId="access-studio-section-proof">
        <TechnicalProof items={sections.technical_proof} />
      </Section>
    </div>
  );
};

export default FiveSectionDetail;
